export interface EmailCampaignOption {
  id: string;
  name: string;
}

/**
 * Выбранные id чипами: рассылка, удалённая или за пределами первых 100,
 * показывается подписью вместо сырого id (пока список грузится, пустой).
 */
export function selectedCampaigns(
  value: string[],
  options: EmailCampaignOption[],
  loading: boolean,
  unknownLabel: string
): EmailCampaignOption[] {
  return value.map(
    (id) =>
      options.find((option) => option.id === id) ?? {
        id,
        name: loading ? "" : unknownLabel,
      }
  );
}
